import { render } from "./UnUploadedReceiptReport.vue?vue&type=template&id=80853712&scoped=true"
import script from "./UnUploadedReceiptReport.vue?vue&type=script&lang=js"
export * from "./UnUploadedReceiptReport.vue?vue&type=script&lang=js"

import "./UnUploadedReceiptReport.vue?vue&type=style&index=0&id=80853712&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80853712"]])

export default __exports__